import React from 'react';
import { Button, Tooltip } from 'antd';
import {PropertyFull} from "../../../types";
import {AuditOutlined} from '@ant-design/icons';
export interface ComparePropertyActionProps {
    property: PropertyFull;
    isSelected: boolean;
    /**
     * Функция, вызываемая при клике – например, для установки выбранного свойства для сравнения.
     */
    onCompare: (property: PropertyFull) => void;
}

const ComparePropertyAction: React.FC<ComparePropertyActionProps> = ({
                                                                         property,
                                                                         isSelected,
                                                                         onCompare,
                                                                     }) => {
    return (
        <Tooltip title="Сравнить">
            <Button
                icon={<AuditOutlined />}
                onClick={() => onCompare(property)}
                style={{
                    color: isSelected ? 'white' : undefined,
                    backgroundColor: isSelected ? '#1890ff' : undefined,
                }}
                type={isSelected ? 'primary' : 'default'}
            />
        </Tooltip>
    );
};

export default ComparePropertyAction;
